/* eslint-disable */
export const debounce = (func) => {
	let timer;
	return (event) => {
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(func, 100, event);
	};
};


/**
 * https://gist.github.com/r3lk3r/0030bab99347a2326334e00b23188cab#file-focusloopingutil-js
 * Selectors for all focusable elements
 * @type {string}
 */
const KEY_CODE_MAP = {
	TAB: 9,
};

/**
 * A stateless keyboard utility to -
 * - Trap focus,
 * - Focus the correct Element
 * @param config {
 *   el: HTMLElement. The Parent element, within which the focus should be trapped
 *   focusElement: <Optional> HTMLElement. If Not provided, focus is put to the first focusable element
 * }
 * @return {Function} Function. The cleanup function. To undo everything done for handling A11Y
 */

export function loopFocus(config) {
	if (!config) {
		throw new Error('Could not initialize focus-trapping - Config Missing');
	}

	const el = config.el,
		focusElement = config.focusElement;

	if (!el) {
		throw new Error('Could not initialize focus-trapping - Element Missing');
	}

	const focusableElements = el.querySelectorAll(config.FOCUSABLE_ELEMENT_SELECTORS);
	let keyboardHandler;

	// There can be containers without any focusable element
	if (focusableElements.length > 0) {
		const firstFocusableEl = focusableElements[0],
			lastFocusableEl = focusableElements[focusableElements.length - 1],
			elementToFocus = focusElement || firstFocusableEl;
			elementToFocus.focus();

		keyboardHandler = function keyboardHandler(e) {
			if (e.keyCode === KEY_CODE_MAP.TAB) {
				//Rotate Focus
				if (e.shiftKey && document.activeElement === firstFocusableEl) {
					e.preventDefault();
					lastFocusableEl.focus();
				} else if (!e.shiftKey && document.activeElement === lastFocusableEl) {
					e.preventDefault();
					firstFocusableEl.focus();
				}
			}
		};
		el.addEventListener('keydown', keyboardHandler);
	}

	//The cleanup function. Put future cleanup tasks inside this.
	return function cleanUp() {
		if (keyboardHandler) {
			el.removeEventListener('keydown', keyboardHandler);
		}
	};
}

export const gaEvent = ({ event, eventCategory, eventAction, eventLabel, form_type }) => {
	if (window && window.dataLayer) {
		window.dataLayer.push({
			event,
			eventCategory,
			eventAction,
			eventLabel,
			form_type
		});
	}
};

export function prefersReducedMotion() {
    if (!'matchMedia' in window) {
        return false;
    }

    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!motionQuery.matches) {
        return false;
    }

    return true;
}


/**
 * - Set Aria-Hidden loop through for screen readers
 * @param config {
 *   value : true|false ,
 *   element : element where the aria-hidden has to be set. 
 * }
 * 
 */

export function loopAriaHidden(config){

	if(!config){
		throw new Error('Could not initialize Aria-Hidden - Config Missing');
	}
	const value = config.value,
		element = config.element;

	const el = document.querySelector(element);

	if(!el){
		throw new Error('Could not initialize Aria-Hidden - Element Missing');
	}

	// set aria-hidden of the Element 
	el.setAttribute('aria-hidden', value);
	
	//toggle Aria-hidden to other parents 
	// header and footer - set those first
	document.querySelector('header').setAttribute('aria-hidden',!value);
	document.querySelector('footer').setAttribute('aria-hidden',!value);

	//Get all the parent decendant to the element
	let descendant = el.parentElement.children;
	Array.from(descendant).forEach(function(child) {
		if(!child.matches(element)){
			child.setAttribute('aria-hidden', !value);
		}
	});
	return true;
}

/* eslint-enable */
